export const Colors = {
  primary: "#ee2737",
  secondary: "#851fc8",

  //------------- Text -------------
  text0: "#000000",
  text1: "#ffffff",
  text2: "#bdbdbd",
  text3: "#7b808d",
  text4: "#6a6a6a",

  //------------- Border -------------
  border1: "rgba(255, 255, 255, 0.20)",
  border2: "rgba(255, 255, 255, 0.40)",
  border3: "rgba(255, 255, 255, 0.60)",
  border4: "rgba(255, 255, 255, 0.80)",

  //------------- Backgrounds -------------
  background0: "#ffffff",
  background1: "#111622",
  background2: "#1b2337",
  background3: "#292a3b",
  background4: "#3b3d4c",
  background5: "rgba(17, 22, 34, 0.50)",
  background6: "rgba(255, 255, 255, 0.08)",
  topRankBg:
    "linear-gradient(90deg, #1e2844 10.85%, rgba(37, 51, 89, 0.00) 82.22%)",
  vipBg:
    "linear-gradient(325deg, #de9239 -24.57%, #fdd74e 49.37%, #de9239 108.65%)",

  //------------- System -------------

  error: "#d12020",
  errorBackground: "#feefe",
  warning: "#b95000",
  warningBackground: "#fff4ec",
  expired: "#2e5aac",
  expiredBackground: "#eef2fa",
  confirm: "#287d3c",
  confirmBackground: "#edf9f0",
  highlight: "#ffd400",

  statusOnline: "#2bd744",
  statusOffline: "#bbbbbb",
  statusAway: "#ff993e",

  rankGolden: "#ffd54b",
  rankSilver: "#b5b5b5",
  rankBronze: "#cb7c44",
  rankOther: "#484848",
};

const Radius = {
  button: 2,
  sSmall: 4,
  small: 8,
  medium: 16,
  large: 24,
};

const Spacing = {
  space2: 2,
  space4: 4,
  space8: 8,
  space12: 12,
  space16: 16,
  space20: 20,
  space24: 24,
  space32: 32,
  space40: 40,
  space48: 48,
};

const FontWeight = {
  bold: 700,
  semiBold: 600,
  medium: 500,
  regular: 400,
};

const ZIndex = {
  normal: 1,
  appBar: 110,
  dialog: 1900,
};

const FontFamily = "Poppins";

export const DefaultTheme = {
  colors: Colors,
  radius: Radius,
  spacing: Spacing,
  fontWeight: FontWeight,
  zIndex: ZIndex,
  fontFamily: FontFamily,
};

export type ITheme = typeof DefaultTheme;

export enum ThemeName {
  Ca = "Ca",
  VinaphoneVietNam = "Vinaphone VietNam",
  ViGame = "Vi Game",
  ChallengeArena = "challenge Arena",
  Africell = "Africell",
  VodaphoneIndia = "Vodaphone India",
  U9 = "U9",
  VodacomSa = "Vodacom SA",
  Safaricom = "Safaricom",
  Dialog = "Dialog",
  Robi = "Robi",
}
